
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import FormContainer from "../../../../../common/components/form_container";
import BottomBar from "../../../../../common/components/bottom_bar";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { TransferList } from "../../../../rh/presentation/pages/TreinamentoFuncionario_cadastro/components/transfer_list";
import { DropDownCentroCusto } from "../../../../../common/components/dropdown_centro_custo";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import { BackButton } from "../../../../../common/components/back_button";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { DefaultFormNumericInput } from "../../../../../common/components/default_form_numeric_input";
import { DefaultFormRadioGroupInput } from "../../../../../common/components/default_form_radio_group_input";
import { useMemo } from "react";
import { useImpressaoCadastroGerenciarViewModel } from "../../viewModels/impressao_cadastrogerenciar_view_model";
import { DropDownFornecedor } from "../../../../../common/components/dropdown_fornecedor";
import { SendMailModal } from "../../../../../common/components/send_email_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { isValidId } from "../../../../../common/utils/utils";

export const Impressao_cadastrogerenciar = () => {
  const viewModel = useImpressaoCadastroGerenciarViewModel();

  const statusOptions = useMemo(() => {
    return [
      {
        id: 0,
        label: 'Pendente',
        style: {
          backgroundColor: '#d3d3d3',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 1,
        label: 'Aprovada',
        style: {
          backgroundColor: '#45b6af',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 2,
        label: 'Reprovada',
        style: {
          backgroundColor: '#f3565d',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      }

    ];
  }, [
  ]);


  const corOptions = useMemo(() => {
    return [
      {
        id: 0,
        label: 'Preto e Branco',
        style: {
          backgroundColor: '#d3d3d3',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 1,
        label: 'Colorido',
        style: {
          backgroundColor: '#45b6af',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },

    ];
  }, [
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <BackButton onClick={() => window.history.back()} />
            </div>
          }
        />
      </PageTopBar>

      <form onSubmit={viewModel.handleSubmitProjetoImpressao}>
        <div className=" flex w-full gap-6 flex-col py-10 px-4 mb-16 ">
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit">
              Projetos
            </Link>
            <Typography className="text-primary-green ">Cadastro de Solicitação de Impressão</Typography>
          </Breadcrumbs>

          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium dark:dark:text-zinc-100 ">
              Cadastro Solicitação de Impressão
            </h1>
            <RefreshButton onClick={viewModel.handleReloadPage} />
          </div>

          <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>

            <FormContainer title="Dados da Solicitação" arrangement="fullRow" border>
              <div className="w-full flex flex-col  gap-4">



                <div className="w-full grid grid-cols-2 gap-4">
                  <DefaultFormRadioGroupInput
                    name='status'
                    label='Status'
                    options={statusOptions}
                    reactHookForm={viewModel.hookForm}
                  />
                  {/* <div className="flex items-center justify-center w-full h-full gap-2">
                    <IconButton onClick={() => { viewModel.handleEmailOpenState(true) }}>
                      <DynamicIcon nameIcon="EmailOutlined" size={35} className="text-[#009C4E]" />
                      <span className="ml-1 text-sm text-gray-700">
                        {viewModel.selectedProjetoImpressao?.statusEmail ? 'Email já Enviado' : 'Enviar Email'}</span>
                    </IconButton>
                </div> */}
                </div>

                {viewModel.status === 1 &&
                  <>
                    <div className="w-full grid grid-cols-2 gap-4">
                      <DropDownFuncionario
                        name="idFuncionarioAprovacao"
                        label="Responsável"
                        required
                        reactHookForm={viewModel.hookForm}
                      />
                      <FormDatePickerInput
                        name="dataAprovacao"
                        label="Data"
                        required
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <div className="w-full grid grid-cols-2 gap-4">
                      <DefaultFormRadioGroupInput
                        name='cor'
                        label='Cor'
                        options={corOptions}
                        reactHookForm={viewModel.hookForm}
                      />
                      <DefaultFormNumericInput
                        name="quantidade"
                        label="Quantidade"
                        required
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <div className="w-full grid grid-cols-2 gap-4">
                      <DefaultFormInput
                        name="tamanho"
                        label="Tamanho"
                        reactHookForm={viewModel.hookForm}
                      />

                      <DropDownFornecedor
                        name="idFornecedor"
                        label="Copiadora"
                        reactHookForm={viewModel.hookForm}
                      />

                    </div>

                    <DefaultFormInput
                      name="observacoesSolicitacao"
                      label="Observações"
                      multiline
                      rows={3}
                      reactHookForm={viewModel.hookForm}
                    />
                  </>
                }

              </div>

            </FormContainer>


            <fieldset disabled={true} >

              <FormContainer title="Detalhes da Solicitação de Impressão" arrangement="fullRow" border>
                <div className="w-full flex flex-col  gap-4">

                  <div className="w-full grid grid-cols-2 gap-4">
                    <DropDownCentroCusto
                      name="idCentroCusto"
                      label="Centro de Custo"
                      required
                      readOnly
                      reactHookForm={viewModel.hookForm}
                    />

                    <FormDatePickerInput
                      name="dataSolicitacao"
                      label="Data Solicitação"
                      required
                      readOnly
                      reactHookForm={viewModel.hookForm}
                    />

                  </div>

                  <div className="w-full grid grid-cols-2 gap-4">
                    <DefaultFormAutocomplete
                      name='idProjeto'
                      label='Projeto'
                      readOnly
                      options={viewModel.ddlProjetos ?? []}
                      getOptionKey={x => x.id}
                      getOptionLabel={x => x.title}
                      reactHookForm={viewModel.hookForm}

                    />

                    <DropDownFuncionario
                      name="idFuncionarioSolicitante"
                      label="Solicitante"
                      required
                      readOnly
                      reactHookForm={viewModel.hookForm}
                    />

                  </div>
                </div>
              </FormContainer>

              <FormContainer title="Disciplinas/Subdisciplinas" arrangement="fullRow" border>
                <TransferList
                  sourceList={viewModel.disciplinasNaoCadastradas}
                  destinationList={viewModel.disciplinasCadastradas}
                  sourceListTitle="Selecione as Disciplinas/Subdisciplinas"
                  destinationListTitle="Disciplinas/Subdisciplinas Selecionados"
                  getItemKey={(x) => x.idDisciplina}
                  getItemLabel={(x) => x.descricao}
                  onSelectionChange={viewModel.handleChangeDisciplinasLista}
                />
              </FormContainer>

            </fieldset>
          </div>

        </div>

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {
                isValidId(viewModel.selectedProjetoImpressao) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>

            <div className="w-full flex justify-end items-center gap-4 p-4">
              {
                viewModel.status === 1 &&
                <>
                  <div className="p-2 cursor-pointer font-semibold" onClick={() => window.history.back()}>
                    Cancelar
                  </div>

                  <div className="w-[130px]">
                    {viewModel.loading ? (
                      <PrimaryButton>Salvando...</PrimaryButton>
                    ) : (
                      <PrimaryButton type="submit" startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                        Salvar
                      </PrimaryButton>
                    )}
                  </div>
                </>
              }
            </div>
          </div>
        </BottomBar>

      </form >

      <SendMailModal
        open={viewModel.openEmailModal}
        loading={viewModel.loading}
        sendTo={viewModel.emailSendTo}
        subject={viewModel.emailSubject}
        attachment={viewModel.emailAttachment}
        body={viewModel.emailBody}
        onClose={() => viewModel.handleEmailOpenState(false)}
        onSubmit={viewModel.handleEmailSubmit}
      />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />


    </>
  );
};
